module.exports = __webpack_public_path__ + "slider-right-arrow.svg?4e07fcfd3d3e5ab53cf34761498ccf80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-right-arrow.svg
// module id = 144
// module chunks = 0